import PayoneerExplanation from './payoneer-explanation';

export default PayoneerExplanation;
